export enum StudyType {
  DRUG = 'DRUG',
  MEDICAL_PRODUCT = 'MEDICAL_PRODUCT'
}
